import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: 'https://vehicle-tax-buddy.webxlabs.in', // API base URL
})

axiosInstance.interceptors.request.use(
  async function (config) {
    let token = localStorage.getItem('token')
    token = token ? token : ''

    // Add the token to the Authorization header with 'Bearer' prefix
    if (token) {
      config.headers.Authorization = `${token}`
    }

    // Check if the request is multipart, then set the appropriate Content-Type
    if (config.isMultipart) {
      config.headers['Content-Type'] = 'multipart/form-data'
    } else {
      config.headers['Content-Type'] = 'application/json'
    }

    return config
  },
  function (error) {
    // Handle request error
    return Promise.reject(error)
  },
)

export default axiosInstance